import {
    ADD_FAVOURITE_PROJECT_SUCCESS,
    FETCH_ALL_PROJECT_SUCCESS,
    FETCH_PROJECT_SUCCESS,
    FILTER_PROJECT,
    GET_ALL_PROJECT,
    GET_UNSELECTED_ALL_PROJECT,
    HANDLE_PROJECT_REQUEST_CLOSE,
    HIDE_PROJECT_LOADER,
    SHOW_PROJECT_LOADER,
    ON_ADD_PROJECT,
    ON_ALL_PROJECT_SELECT,
    ON_PROJECT_CLOSE,
    ON_PROJECT_SELECT,
    ON_DELETE_PROJECT_SUCCESS,
    ON_DELETE_SELECTED_PROJECT,
    ON_FILTER_PROJECT_OPTION_SELECT,
    ON_SAVE_PROJECT_SUCCESS,
    ON_TOGGLE_PROJECT_DRAWER,
    SHOW_PROJECT_MESSAGE,
    UPDATE_SEARCH_PROJECT,
    ON_PROJECT_PRIORITY_DASHBOARD,
    CLEAR_SESSION,
    FETCH_IMPORT_PROJECTS_SUCCESS,
    SHOW_IMPORT_PROJECTS_LOADER,
    HIDE_IMPORT_PROJECTS_LOADER,
    ON_IMPORT_PROJECTS_SUCCESS,
    ON_PROJECT_ISSUES_DASHBOARD,
    ON_SAVE_PROJECT_CACHE_SUCCESS,
    SET_PROJECT,
    CLEAR_SELECTED_OBJECTS,
} from 'constants/ActionTypes';
import { SETUP_IMPORT, HAS_PROJECTS_TO_IMPORT, NO_PROJECTS_TO_IMPORT } from 'constants/project';
import { addOrUpdateEntry } from 'services/arrayService';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No projects found in selected folder',
    importProjectMessage: SETUP_IMPORT,
    selectedSectionId: 1,
    drawerState: false,
    filterOption: 'All projects',
    allProject: [],
    projectList: [],
    selectedProject: null,
    selectedProjects: 0,
    addProjectState: false,
    searchProject: '',
    importLoader: false,
    importedProjects: [], // this list is filtered in the saga - its not the whole list from JIRA
    projectCacheList: [],
    projectDependencyList: [],
    selectedDependencyProjects: 0,
    project: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedProject: null,
            };
        }
        case ON_SAVE_PROJECT_CACHE_SUCCESS: {
            return {
                ...state,
                projectCacheList: action.payload,
            };
        }
        case ON_PROJECT_ISSUES_DASHBOARD: {
            return {
                ...state,
                loader: false,
                selectedProject: action.payload,
            };
        }
        case ON_PROJECT_PRIORITY_DASHBOARD: {
            return {
                ...state,
                loader: false,
                selectedProject: action.payload,
            };
        }
        case ADD_FAVOURITE_PROJECT_SUCCESS: {
            const allUpdated = state.allProject.map((entry) => entry ?.id === action ?.payload ?.id ? {
                ...entry,
                starred: !action ?.payload ?.starred
            } : entry);
            let listUpdated = {};
            switch (state.filterOption) {
                case 'All projects': {
                    listUpdated = allUpdated;
                    break;
                }
                case 'Starred projects': {
                    listUpdated = allUpdated.filter((entry) => entry.starred);
                    break;
                }
            }
            return {
                ...state,
                alertMessage: action.payload.starred ? 'Project removed as star' : 'Project marked as star',
                showMessage: true,
                projectList: listUpdated,
                allProject: allUpdated
            };
        }
        case SET_PROJECT: {
            const project = state.allProject.filter((entry) => entry?.id === action?.payload);
            return {
                ...state,
                loader: false,
                selectedProject: project?.length > 0 ? project[0] : [],
            };
        }
        case FETCH_IMPORT_PROJECTS_SUCCESS: {
            return {
                ...state,
                importLoader: false,
                importedProjects: action.payload,
                importProjectMessage: action.payload ?.length > 0 ? HAS_PROJECTS_TO_IMPORT : NO_PROJECTS_TO_IMPORT
            };
        }
        case ON_IMPORT_PROJECTS_SUCCESS: {
            return {
                ...state,
                loader: false,
                importLoader: false,
                allProject: action.payload,
                projectList: action.payload,
                importedProjects: [],
                importProjectMessage: SETUP_IMPORT,
            };
        }
        case FETCH_PROJECT_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedProject: action.payload,
            };
        }
        case FETCH_ALL_PROJECT_SUCCESS: {
            return {
                ...state,
                loader: false,
                importLoader: false,
                allProject: action.payload,
                projectList: action.payload,
                selectedSectionId: 1,
                searchProject: '',
                filterOption: 'All projects',
                importedProjects: [],
                importProjectMessage: SETUP_IMPORT,
            };
        }
        case SHOW_PROJECT_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                importLoader: false,
                loader: false
            };
        }
        case ON_PROJECT_SELECT: {
            // invoked when selecting dependant projects (blocking and blocked by)
            // set the selectable project list property for the update
            action.payload.selected = !action.payload.selected;
            let selectedDependencyProjects = 0;
            const projectDependencyList = state.projectDependencyList.map(project => {
                if (project.selected) {
                    selectedDependencyProjects++;
                }
                if (project.id === action.payload.id) {
                    if (project.selected) {
                        selectedDependencyProjects++;
                    }
                    return action.payload;
                } else {
                    return project;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedDependencyProjects: selectedDependencyProjects,
                projectDependencyList: projectDependencyList
            };
        }
        case ON_ADD_PROJECT: {
            return { ...state, addProjectState: true };
        }
        case ON_PROJECT_CLOSE: {
            return { ...state, addProjectState: false };
        }
        case ON_FILTER_PROJECT_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let projectList = [];
            switch (action.payload.name) {
                case 'All projects': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    projectList = state.allProject;
                    break;
                }
                case 'Starred projects': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    projectList = state.allProject.filter((project) => project.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, projectList, drawerState: false
            };
        }
        case ON_SAVE_PROJECT_SUCCESS: {
            return {
                ...state,
                alertMessage: 'Project Updated Successfully',
                showMessage: true,
                projectList: addOrUpdateEntry(state.projectList, action.payload),
                allProject: addOrUpdateEntry(state.allProject, action.payload),
                selectedProject: action.payload,
                loader: false,
            };
        }
        case ON_DELETE_PROJECT_SUCCESS: {
            return {
                ...state,
                alertMessage: 'Project Deleted Successfully',
                showMessage: true,
                allProject: state.allProject.filter((project) => project.id !== action.payload.id),
                projectList: state.allProject.filter((project) => project.id !== action.payload.id),
                selectedProject: null,
            };
        }
        // this is not ctually deleting the project - just filtering from the view
        case ON_DELETE_SELECTED_PROJECT: {
            const projects = state.allProject.filter((project) => !project.selected);
            return {
                ...state,
                alertMessage: 'Project(s) Filtered Successfully',
                showMessage: true,
                projectList: projects,
                selectedProjects: 0,
            };
        }
        case FILTER_PROJECT: {
            const { filterOption } = state;
            let projectList = [];
            if (action.payload === '') {
                projectList = state.allProject;
            } else {
                const filterProject = state.allProject.filter((project) =>
                    project.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === 'All projects') {
                    projectList = filterProject;
                } else if (filterOption === 'Starred projects') {
                    projectList = filterProject.filter((project) => project.starred);
                }
            }
            return { ...state, projectList: projectList };
        }
        case GET_ALL_PROJECT: {
            let projectList = state.allProject.map((project) => project ? {
                ...project,
                selected: true
            } : project);
            return {
                ...state,
                selectedProjects: projectList.length,
                allProject: projectList,
                projectList: projectList
            };
        }
        case GET_UNSELECTED_ALL_PROJECT: {
            let projectList = state.allProject.map((project) => project ? {
                ...project,
                selected: false
            } : project);
            return {
                ...state,
                selectedProjects: 0,
                allProject: projectList,
                projectList: projectList
            };
        }
        case ON_ALL_PROJECT_SELECT: {
            const selectAll = state.selectedProjects < state.projectList.length;
            let selectedProjects = 0;
            let projectList = [];
            if (selectAll) {
                projectList = state.allProject.map((project) => project ? {
                    ...project,
                    selected: true
                } : project);
                selectedProjects = projectList.length;
            } else {
                projectList = state.allProject.map((project) => project ? {
                    ...project,
                    selected: true
                } : project);
                selectedProjects = 0;
            }
            return {
                ...state,
                selectedProjects: selectedProjects,
                allProject: projectList,
                projectList: projectList
            };
        }
        case UPDATE_SEARCH_PROJECT: {
            return { ...state, searchProject: action.payload };
        }
        case HANDLE_PROJECT_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_PROJECT_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_PROJECT_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_PROJECT_LOADER: {
            return { ...state, loader: false };
        }
        case SHOW_IMPORT_PROJECTS_LOADER: {
            return { ...state, importLoader: true };
        }
        case HIDE_IMPORT_PROJECTS_LOADER: {
            return { ...state, importLoader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/project.js